import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      colsSize: [1, 3],
      gap: "30px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                // alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data:
                    "Auralization and vehicle sound simulation can be usefull in many different NVH realted tasks and applications including virtual prototyping, active sound design (ASD), engine sound enhancement (ESE), and benchmarking. Furthermore, ....  \n" +
                    "\n" +
                    "<br />" +
                    "<br />" +
                    "Being able to simulate a vehicle with the help of known transfer paths can greatly accelerate the design process. The next step in this development is to derive transfer paths directly from simulation data and accurately predict and auralize changes to the system, before any kind of prototyp exists.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/8-cae.png`,
                  viewType: "contain",
                  styles: {
                    maxWidth: "663px",
                  },
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
